<template>
  <div>
    <div class="examine-box">
      <div class="DoT-one1"></div>
      <div class="DoT-two2"></div>
      <div class="Training">
        <p class="examine-p1">{{$t('i.common.examination')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "examine"
  }
</script>

<style scoped>

  .examine-box{
    width: 300px;
    height: 33px;
  }
  .DoT-one1{
    width: 10px;
    height: 10px;
    margin-left: 85px;
    background-color: #e50020;
    float: left;
  }
  .DoT-two2{
    width: 10px;
    height: 10px;
    margin-left: -10px;
    margin-top: 20px;
    background-color: #a8a8a9;
    float: left;
  }

  .Training{
    width: 200px;
    height: 33px;
    margin-left: 110px;
    padding-top: 1px;
  }
  .examine-p1{
    font-size: 30px;
    margin-top: -10px;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/examine.vue